<template>
  <div>
    <div class="section-head">红包配置</div>
    <div class="red-tiers-actions">
      <el-button type="primary" size="mini" @click="addRedTier">新增</el-button>
    </div>
    <el-table :data="redTiers" border size="mini" class="tier-table red-tier-table">
      <el-table-column label="序号" width="56" align="center">
        <template slot-scope="scope">{{ scope.$index + 1 }}</template>
      </el-table-column>
      <el-table-column label="获取到红包个数" min-width="240">
        <template slot-scope="scope">
          <div v-if="!scope.row.isGuarantee" style="display: flex; align-items: center; gap: 6px">
            <el-select v-model="scope.row.num_interval_type" size="mini" style="width: 70px">
              <el-option label="≥" :value="RED_NUM_INTERVAL_GTE" />
              <el-option label=">" :value="RED_NUM_INTERVAL_GT" />
            </el-select>
            <el-input-number v-model="scope.row.num" :min="0" :precision="0" :controls="false" size="mini" style="width: 90px" />
          </div>
        </template>
      </el-table-column>
      <el-table-column label="奖励类型" width="160">
        <template slot-scope="scope">
          <el-select v-model="scope.row.reward_type" size="mini" style="width: 120px" :disabled="scope.row.isGuarantee" @change="onRedTierRewardTypeChange(scope.$index)">
            <el-option label="随机奖励" :value="RED_REWARD_TYPE_RANDOM" />
            <el-option label="固定奖励" :value="RED_REWARD_TYPE_FIXED" />
            <el-option label="保底奖励" :value="RED_REWARD_TYPE_GUARANTEE" :disabled="!scope.row.isGuarantee" />
          </el-select>
        </template>
      </el-table-column>
      <el-table-column label="奖励数" min-width="240">
        <template slot-scope="scope">
          <div v-if="scope.row.reward_type === RED_REWARD_TYPE_RANDOM" style="display: flex; align-items: center; gap: 6px">
            <el-input-number v-model="scope.row.reward_count_min" :min="0" :precision="2" :controls="false" size="mini" style="width: 92px" />
            <span class="rule-suffix" style="font-size: 13px; color: #606266">~</span>
            <el-input-number v-model="scope.row.reward_count_max" :min="0" :precision="2" :controls="false" size="mini" style="width: 92px" />
          </div>
          <el-input-number v-else v-model="scope.row.reward_count" :min="0" :precision="0" :controls="false" size="mini" style="width: 120px" />
        </template>
      </el-table-column>
      <el-table-column label="库存" width="170">
        <template slot-scope="scope">
          <div class="tier-stock-line">
            <el-checkbox v-model="scope.row.total_unlimited" :disabled="scope.row.isGuarantee" size="mini">不限</el-checkbox>
            <el-input-number
              v-if="!scope.row.isGuarantee"
              :disabled="scope.row.total_unlimited"
              v-model="scope.row.total"
              :min="0"
              :precision="0"
              :controls="false"
              size="mini"
              class="tier-stock-input"
            />
          </div>
        </template>
      </el-table-column>
      <el-table-column label="已发放" width="72" align="center">
        <template slot-scope="scope">{{ scope.row.available_num }}</template>
      </el-table-column>
      <el-table-column label="操作" width="72" align="center">
        <template slot-scope="scope">
          <el-button v-if="!scope.row.isGuarantee" type="text" size="small" class="danger-button" @click="removeRedTier(scope.$index)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script setup>
const RED_REWARD_TYPE_RANDOM = 1
const RED_REWARD_TYPE_FIXED = 2
const RED_REWARD_TYPE_GUARANTEE = 3

const RED_NUM_INTERVAL_GTE = 1
const RED_NUM_INTERVAL_GT = 2

const props = defineProps({
  redTiers: {
    type: Array,
    required: true,
  },
})

function createEmptyRedTier() {
  return {
    id: 0,
    isGuarantee: false,
    num_interval_type: RED_NUM_INTERVAL_GTE,
    num: 1,
    reward_type: RED_REWARD_TYPE_RANDOM,
    reward_count_min: 0,
    reward_count_max: 0,
    reward_count: 0,
    available_num: 0,
    total: 0,
    total_unlimited: true,
    weight: 1,
  }
}

function createDefaultRedGuaranteeTier() {
  return {
    id: 0,
    isGuarantee: true,
    num_interval_type: RED_NUM_INTERVAL_GTE,
    num: 0,
    reward_type: RED_REWARD_TYPE_GUARANTEE,
    reward_count_min: 0,
    reward_count_max: 0,
    reward_count: 20,
    available_num: 0,
    total: 0,
    total_unlimited: true,
    weight: 0,
  }
}

function onRedTierRewardTypeChange(index) {
  const row = props.redTiers[index]
  if (!row || row.isGuarantee) return
  const rt = Number(row.reward_type)

  if (rt === RED_REWARD_TYPE_RANDOM) {
    const min = Number(row.reward_count_min)
    const max = Number(row.reward_count_max)
    if (!Number.isFinite(min) || min < 0) row.reward_count_min = Number(row.reward_count) || 0
    if (!Number.isFinite(max) || max < 0) row.reward_count_max = Number(row.reward_count_min) || 0
    if (Number(row.reward_count_max) < Number(row.reward_count_min)) {
      row.reward_count_max = Number(row.reward_count_min) || 0
    }
    return
  }

  const rewardCount = Number(row.reward_count_min) || Number(row.reward_count) || 0
  row.reward_count = rewardCount
  row.reward_count_min = rewardCount
  row.reward_count_max = rewardCount
}

function addRedTier() {
  const guaranteeIndex = props.redTiers.findIndex(t => t.isGuarantee)
  const insertIndex = guaranteeIndex >= 0 ? guaranteeIndex : props.redTiers.length
  props.redTiers.splice(insertIndex, 0, createEmptyRedTier())
}

function removeRedTier(index) {
  const row = props.redTiers[index]
  if (!row || row.isGuarantee) return
  props.redTiers.splice(index, 1)
  const hasGuarantee = props.redTiers.some(t => t.isGuarantee)
  if (!hasGuarantee) {
    props.redTiers.push(createDefaultRedGuaranteeTier())
  }
}
</script>

<style lang="scss" scoped>
.section-head {
  font-size: 15px;
  font-weight: 600;
  color: #303133;
  margin: 16px 0 12px;
  padding-left: 10px;
  border-left: 4px solid #409eff;
  line-height: 1.2;
}

.tier-table {
  width: 100%;
  margin-bottom: 8px;
}

.rule-suffix {
  color: #606266;
  font-size: 13px;
  margin-left: 4px;
  margin-bottom: 18px;
}

.tier-stock-input {
  width: 86px;
}

.tier-stock-line {
  display: flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
}

.danger-button {
  color: #f56c6c;
}
</style>
